"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerInsightsReportSchema = exports.ChurnRiskRowSchema = exports.TopCustomerRowSchema = void 0;
const zod_1 = require("zod");
exports.TopCustomerRowSchema = zod_1.z.object({
    customerId: zod_1.z.string(),
    name: zod_1.z.string(),
    email: zod_1.z.string().optional(),
    phone: zod_1.z.string().optional(),
    transactions: zod_1.z.number(),
    totalSpend: zod_1.z.number(),
    avgBasket: zod_1.z.number(),
    lastVisitAt: zod_1.z.string().optional(),
    loyaltyPoints: zod_1.z.number().optional(),
});
exports.ChurnRiskRowSchema = zod_1.z.object({
    customerId: zod_1.z.string(),
    name: zod_1.z.string(),
    lastVisitAt: zod_1.z.string().optional(),
    daysSinceLastVisit: zod_1.z.number(),
    lifetimeSpend: zod_1.z.number(),
});
exports.CustomerInsightsReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    enabled: zod_1.z.boolean().default(true),
    totalCustomers: zod_1.z.number(),
    newCustomers: zod_1.z.number(),
    returningCustomers: zod_1.z.number(),
    repeatRatePct: zod_1.z.number(),
    avgLifetimeValue: zod_1.z.number(),
    topCustomers: zod_1.z.array(exports.TopCustomerRowSchema),
    churnRisk: zod_1.z.array(exports.ChurnRiskRowSchema),
    loyaltyPointsEarned: zod_1.z.number(),
    loyaltyPointsRedeemed: zod_1.z.number(),
});
//# sourceMappingURL=customer-insights.schema.js.map